import type { CollectionAdapter, CollectionState } from '@common/adapters/collections';
import type { EduCourseTariff } from '@common/types/edu-course.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionAdapter } from '@common/adapters/collections';

import EduCoursesTariffsActions from './edu-courses-tariffs.actions';

export const EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY = 'eduCoursesTariffs';

export type EduCoursesTariffsCollectionState = CollectionState<EduCourseTariff>;

export const eduCoursesTariffsAdapter: CollectionAdapter<EduCourseTariff> = createCollectionAdapter<EduCourseTariff>();

export const eduCoursesTariffsCollectionReducer = createReducer<EduCoursesTariffsCollectionState>(
    eduCoursesTariffsAdapter.getInitialState(),
    on(EduCoursesTariffsActions.loadCollectionRequest, (state: EduCoursesTariffsCollectionState) =>
        eduCoursesTariffsAdapter.loadCollectionRequest(state)
    ),
    on(EduCoursesTariffsActions.loadCollectionSuccess, (state: EduCoursesTariffsCollectionState, { tariffs }) =>
        eduCoursesTariffsAdapter.loadCollectionSuccess(tariffs, state)
    ),
    on(EduCoursesTariffsActions.loadCollectionFailure, (state: EduCoursesTariffsCollectionState, { error }) =>
        eduCoursesTariffsAdapter.loadCollectionFailure(error, state)
    )
);
